<template>
	<section>
		<div class="row mt-3">
			<div class="container">
				<div class="d-flex justify-content-between">
					<strong>Unidade:</strong>
					<span>{{ resultado.unidade }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Período inicial:</strong>
					<span>{{ resultado.inicio | moment("DD/MM/YYYY") }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Periodo final:</strong>
					<span>{{ resultado.fim | moment("DD/MM/YYYY") }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Ligações</strong>
					<span>{{ resultado.ligacoes }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Tempo total</strong>
					<span>{{ resultado.tempo }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Custo do minuto</strong>
					<span>{{ resultado.custo | brl_real }}</span>
				</div>

				<div class="d-flex justify-content-between">
					<strong>Custo das ligações</strong>
					<span>{{ resultado.custo * resultado.ligacoes | brl_real }}</span>
				</div>

			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'Resumo',
		props: ["resultado"]
	};
</script>

<style>
</style>